/*
 * @Date: 2022-07-04 17:34:30
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
const whiteSpace = '\n\n'

export default {
  companyProfile: {
    title: "公司简介",
    desc1: "本集团成立于2004年，总部位于深圳，是国内首家打造多场景及闭环设备全生命周期管理业务模式的公司，股东包括了腾讯、京东、联想等战略投资者。我们以客户为导向的价值观，指导我们为企业提供围绕设备全生命周期的低成本、高品质、量身定制的一站式综合服务解决方案。我们着眼于满足企业对设备生命周期管理解决方案的需求，提高企业的业务运营效率。直接解决企业在IT设备采购、维护、管理及淘汰处置过程中面临的痛点，通过设备回收业务、设备订阅服务、IT技术订阅服务、设备管理SaaS，缓解企业一次性购买IT设备的巨大资金压力、技术支持响应慢、IT设备管理灵活性不足及IT设备利用率低的问题。设备全生命周期管理作为一种新兴的企业发展趋势，将办公环境轻资产、实现可靠高效设备生命周期管理成为可能。",
    desc2: "自成立以来，我们坚持“让企业轻松办公”的使命，通过帮助企业降低运营成本，实现绿色经济和共享经济、提高IT设备的全生命周期利用率，树立了良好的企业形象。被国务院工信部作为行业标杆认定为“国家中小企业公共服务示范平台”、国家级专精特新“小巨人”企业，代表行业最高服务能力和水平。我们接下来将进一步倡导一个充满活力的企业生态系统。"
  },

  management:{
    title: "管理层成员",
    detailT: "个人简介",
    Hu:{
      name: "胡祚雄先生",
      subName: "董事会主席、执行董事、首席执行官",
      desc: `胡祚雄先生，46岁，于2004年11月创立本集团，自本集团成立以来一直担任本集团董事会主席、首席执行官兼董事。彼于2022年1月10日获委任为我们的董事，并于2022年3月24日调任为我们的执行董事。彼负责本集团的整体管理、营运及战略规划。${whiteSpace}胡先生在设备全生命周期管理行业拥有广泛经验，亦在公司管理、公司治理和信息技术行业拥有愈20年经验。由于胡先生拥有数字化转型以及「互联网+」及产业互联网升级的实际经验，故自2018年5月起，胡先生获委任为中国西南交通大学的客座教授。胡先生亦分别于2019年7月及2018年5月获委任为中国中小企业协会副会长及深圳市商业联合会副会长。${whiteSpace}胡先生于2019年11月被《哈佛商业评论》评为「中国数字化转型先锋人物」之一。彼亦于2023年12月被《金融界》评为「杰出创新发展领袖」之一。于2020年9月，一份载列本集团在胡先生领导下的数字化转型成就的报告获中国北京大学的光华管理学院管理案例研究中心选为教学案例库案例。${whiteSpace}胡先生于1998年6月取得中国湖北理工学院的建造材料与工程专业大专文凭。`,
    },
    Chen: {
      name: "陈修伟先生",
      subName: "执行董事、首席技术官、副总裁",
      desc: `陈修伟先生，38岁，于2019年12月获委任为本集团首席技术官兼副总裁。彼于2022年1月10日获委任为我们的董事，并于2022年3月24日调任为我们的执行董事。彼负责本集团的信息技术应用及研发工作。${whiteSpace}陈先生在信息系统的搭建设计、算法、研发、大数据分析及人工智能方面拥有约13年工作经验。加入本集团之前，于2010年7月至2011年4月，陈先生担任微软亚洲研究院（计算机科学及相关技术研究的专门机构）的助理研究员，主要负责系统开发。于2011年4月至2013年8月，陈先生曾在多家中国TMT（科技、媒体、电信）公司担任首席技术官，并为创办人之一，主要负责研发工作。于2013年8月至2017年8月，彼于联交所主板上市的线上交易服务提供商年年卡集团有限公司（股份代号：3773）担任首席技术官兼副总裁，主要负责研发工作。于2017年9月至2019年12月，陈先生于深圳市前海第四范式数据技术有限公司担任华南首席架构师和项目交付总监，该公司为一家专注于AI技术及相关服务的公司，而彼主要负责系统开发及项目交付。${whiteSpace}陈先生分别于2008年6月及2010年6月取得中国中山大学的计算机科学与技术专业学士学位及计算机软件与理论专业硕士学位。于2007年11月，彼因参加ACM亚洲编程大赛而荣获「长春赛区金奖」。`
    },
    Cao: {
      name: "曹维军先生",
      subName: "执行董事、战略客户中心总经理",
      desc: `曹维军先生，36岁，于2012年3月获委任为本集团战略客户中心总经理。彼于2022年1月10日获委任为我们的董事，并于2022年3月24日调任为我们的执行董事。彼主要负责本集团的客户发展以及战略业务发展。${whiteSpace}加入本集团之前，曹先生于2008年9月至2012年3月在中国一间投资银行及证券经纪公司中国中投证券有限责任公司任职。${whiteSpace}曹先生于2008年7月取得中国武汉生物工程学院的生物技术及应用专业的大专文凭，并于2022年7月取得中国东北师范大学计算机科学与技术本科文凭。`
    },
    Li: {
      name: "李靖先生",
      subName: "非执行董事",
      desc: `李靖先生，42岁，现任集团非执行董事，主要负责本集团的管理、运营及战略规划。同时任京东集团副总裁、京东零售企业业务事业部总裁。${whiteSpace}曾在联想集团有限公司（股票代码：992.HK）任职。${whiteSpace}李先生2002年取得中国北方交通大学（现称北京交通大学）工程学士学位。`
    },
    Jiang: {
      name: "蒋泽立先生",
      subName: "首席财务官、副总裁",
      desc: `蒋泽立先生，41岁，于2019年9月加入本集团担任首席财务官及副总裁，主要负责并监督本集团的财务管理。${whiteSpace}蒋先生在上市公司的审核、会计、财务管理及财务报告方面拥有约21年经验。加入本集团之前，彼于2004年7月至2009年7月任职于会计师事务所，主要负责上市公司的审计相关工作。于2010年3月至2014年12月，彼分别担任唐宫（中国）控股有限公司（一家于联交所主板上市的餐厅营运及食品生产公司，股份代号：1181）及深圳嘉美轩餐饮有限公司（佳兆业集团控股有限公司（股份代号：1638）的附属公司，经营连锁餐饮业务）的财务经理，负责监察公司的财务管理及会计职能。于2014年12月至2019年5月，彼担任深圳兆邦基集团有限公司（一家专门从事商业物业开发及提供物业管理服务的公司）的财务副总监，主要负责监察该公司财务管理及职能。${whiteSpace}蒋先生自2012年12月以来一直为中国注册会计师。彼于2004年6月获得中国中山大学会计学学士学位。`
    },
    Liu: {
      name: "刘炎先生",
      subName: "董事会秘书、资本中心总经理",
      desc: `刘炎先生，33岁，于2018年8月获委任为董事会秘书及资金中心总经理。彼于2022年3月21日获委任为本公司联席公司秘书。刘先生负责并监察本集团企业融资及公司秘书事宜。${whiteSpace}加入本集团之前，彼于2014年4月至2015年3月在中国光大银行股份有限公司（一家于上海证券交易所（股份代号：601818.SH）及联交所主板（股份代号：6818）上市的公司）深圳分行担任客户关系经理，主要负责企业融资业务。于2015年4月至2018年8月，彼担任Shenzhen Zhengwei (Group) Co., Ltd.（《财富》世界500强企业之一）财务中心副总监，主要负责债务融资业务。${whiteSpace}刘先生于2021年4月获得由深圳证券交易所颁发的董事会秘书资格证书。彼亦分别于2015年11月自中国期货业协会获得期货从业人员资格，于2016年5月自中国证券业协会获得基金从业人员资格，并于2016年6月自中国证券投资基金业协会取得证券从业人员资格。刘先生于2012年6月获得中国安徽工业大学国际经济与贸易学士学位。彼其后于2013年12月获得英国格拉斯哥大学国际贸易与金融硕士学位。`
    },
    // Gan: {
    //   name: "甘志成先生",
    //   subName: "独立非执行董事",
    //   desc: `甘志成先生，51岁，在集团担任独立非执行董事。甘先生有超过22年管理会计、审计与鉴证、税务、企业服务和跨境并购咨询经验。目前是香港会计师公会资深会员、特许公认会计师公会资深会员、英国财务会计师公会资深会员、香港税务学会资深会员、英国信托与遗产从业者协会会员和香港证券及投资协会会员。目前是香港总商会税务委员会委员、金融及财资服务委员会委员和中国委员会委员。自2016年起，甘先生一直担任香港中华总商会委员会委员。${whiteSpace}甘先生现任甘志成会计师事务所的执行事务合伙人、卓富德咨询集团的董事总经理及甘志成会计师事务所在上海、广州及北京的代表办事处的首席代表、卓越商企服务集团有限公司（股票代码：6989.HK）的独立非执行董事以及信基沙溪集团有限公司（股票代码：3603.HK）的公司秘书，两间公司均于联交所主板上市。${whiteSpace}甘先生于1993年获得香港大学理学学士学位。`
    // },
    Xu: {
      name: "徐乃玲女士",
      subName: "独立非执行董事",
      desc: `徐乃玲女士，57岁，目前在集团担任独立非执行董事。在金融和投资行业有超过30年经验，被深圳市人力资源和社会保障局认证为高级经济师。${whiteSpace}历任平安银行股份有限公司广州分行行长助理、审计监察部副总经理、风险管理部副经理，中国光大环境（集团）有限公司（“光大环境”，前称中国光大国际有限公司（股票代码：257.HK））财务副总监、中国光大水务有限公司（股票代码：1857.HK）执行董事及光大环保（中国）有限公司董事及财务总监。${whiteSpace}徐女士毕业于西南财经大学金融学专业，并获得厦门大学高级管理人员工商管理硕士学位。`
    },
    Zhao: {
      name: "姚正旺先生",
      subName: "独立非执行董事",
      desc: `姚正旺先生，48岁，目前在公司担任独立非执行董事，拥有超过20年投资及金融行业以及中国A股上市公司企业管治方面的经验。于2010年11月获得深圳证券交易所颁发的董事会秘书资格证书，并于2007年11月获得中国证券监督管理委员会颁发的上市公司高级管理人员培训结业证书。${whiteSpace}历任深圳中华自行车（集团）股份有限公司（000017.SZ；200017.SZ）监事、监事会主席及董事会秘书，现担任董事；历任乐山市商业银行股份有限公司董事，现担任监事。现任深圳市国晟能源投资发展有限公司监事、嘉兴知食坊食品科技有限公司董事、深圳市正瑞能源技术有限公司、深圳市龙鹏投资有限公司及正大能源发展（中国）有限公司监事，以及吉林省富德投资控股有限公司总经理。${whiteSpace}姚先生1997年取得汕头大学法学学士学位。`
    },
    Zhou: {
      name: "邹盛和先生",
      subName: "独立非执行董事",
      desc: `邹盛和先生，57岁，自2024年11月15日起获委任为独立非执行董事，主要负责就本集团的营运、投资及管理提供独立意见。邹先生拥有逾42年财务管理经验。自1982年至2005年，邹先生先后于湖北及深圳的多家公司担任经理及财务负责人等多个职位。邹先生先后于2005年至2010年及2010年至2015年担任深圳丹邦科技股份有限公司（一家曾于深圳证券交易所上市的公司，深交所股票代码：002618；中央结算系统股份代号：72618）的财务总监及监事会主席。邹先生于2015年加入东莞市本润机器人科技股份有限公司（「本润机器人」，一家曾于全国中小企业股份转让系统上市的公司，股票代码：870887），先后担任董事及董事会主席。邹先生现任本润机器人董事。${whiteSpace}邹先生于1986年获得湖北广播电视大学财务管理专业大专文凭。`
    },
  },

  corporate: {
    title: "公司治理",
    desc: "致力于保持专业化、规范化和透明化的治理机制。",
    table: {
      title: "董事会组成",
      tag_1: "执行董事",
      tag_2: "非执行董事",
      tag_3: "独立非执行董事",
      tag_4: "审计委员会",
      tag_5: "薪酬委员会",
      tag_6: "提名委员会",
      Hu: "胡祚雄",
      Chen: "陈修伟",
      Cao: "曹维军",
      Li: "李靖",
      // Gan: "甘志成",
      Xu: "徐乃玲",
      Zhao: "姚正旺",
      Zhou: "邹盛和",
      descTag1: "主席",
      descTag2: "成员",
    }
  },

  documents: {
    title: "公司治理文件"
  },

  committee: {
    title: "委员会章程"
  },

  irNetwork: {
    title: "投资者关系联络",
    contact: "联系我们",
    address: "深圳（总部）：深圳市福田区梅林街道孖岭社区凯丰路10号翠林大厦5层501",
    phone: "电话：",
    mailbox: "邮箱：",
  }
}
